import { FormValidationFunction } from '@/views/interfaces/vuetify/form.interface';

export default class AddSmsForm {
  public senderName:string;
  public clientPhoneNumber:string
  public message: string;

  public rules: { [key: string]: FormValidationFunction[] } = {
    senderName: [
      (v: string) => !!v || 'Template Name is required',
      (v: string) => v.length > 2 || 'Template Name should be at least 3 characters long',
    ],
    clientPhoneNumber: [
      (v: string) => !!v || 'Please select clientPhoneNumber',
    ],
    message: [
      (v: string) => !!v || 'Please enter a message',
    ],
  }
}
